export enum UserRoleEnum {
  SUPER_ADMIN = 'SUPER_ADMIN',
  ADMIN = 'ADMIN',
  AGENT = 'AGENT',
  CLIENT_REGISTRY ='CLIENT_REGISTRY',
  CLIENT_REGISTRAR ='CLIENT_REGISTRAR',
  REGISTRAR = 'REGISTRAR',
  REGISTRY = 'REGISTRY'
}

export enum ServingForEnum {
  MYSELF = 'MYSELF',
  ANOTHER = 'ANOTHER'
}

export enum NationalityEnum {
  CITIZEN = 'CITIZEN',
  NON_CITIZEN = 'NON_CITIZEN'
}

export enum EGender {
  MALE = 'MALE',
  FEMALE = 'FEMALE'
}

